import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";

export default function AppGrid({ apps, testidPrefix = "app-tile" }) {
  const { lang } = useLang();
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3 sm:gap-4">
      {apps.map((app, i) => {
        const Icon = app.icon;
        const desc = lang === "nl" ? app.dNl : app.dEn;
        return (
          <motion.div
            key={app.key}
            data-testid={`${testidPrefix}-${app.key}`}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.45, delay: (i % 7) * 0.05 }}
            className="group relative flex flex-col items-center justify-center gap-3 rounded-[22px] bg-white border border-slate-200/80 px-3 py-6 text-center shadow-[0_8px_30px_-18px_rgba(15,23,42,0.18)] transition-all duration-300 hover:-translate-y-1.5 hover:border-u-purple/40 hover:shadow-[0_18px_40px_-18px_rgba(139,92,246,0.4)] cursor-pointer overflow-hidden min-h-[140px]"
          >
            <div className="relative flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-slate-50 to-white border border-slate-200/80 text-u-ink group-hover:text-u-purple transition-colors">
              <Icon size={22} strokeWidth={1.6} />
            </div>
            <span className="relative text-xs sm:text-[13px] font-medium text-slate-700 leading-tight">
              {app[lang]}
            </span>

            {/* Hover description overlay (editable text in i18n/apps.js) */}
            <div
              data-testid={`${testidPrefix}-${app.key}-desc`}
              className="pointer-events-none absolute inset-0 flex items-center justify-center rounded-[22px] bg-white/95 backdrop-blur-sm p-4 opacity-0 translate-y-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0"
            >
              <p className="text-xs leading-snug text-slate-600">{desc}</p>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
}
